import achievementService from '@/services/api/achievement/achievement'
import achievementCareerService from '@/services/api/achievement/career'


export default {
	namespaced:true,
	modules:{
    achievement: achievementService,
    career: achievementCareerService
  }
}
